import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, DownloadIcon } from 'lucide-react';
import { deliverables } from '../data/deliverables';
import { CtaButton } from './CtaButton';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Deliverables() {
  const [index, setIndex] = useState(0);
  const item = deliverables[index];
  const go = (dir: number) => setIndex(i => (i + dir + deliverables.length) % deliverables.length);
  return <section className="w-full bg-white" data-id="element-17" data-mp="1izrchy941clc">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" data-id="element-18" data-mp="1j2x0tb9x0ag0">
        <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-19" data-mp="1wzk8o93eol0p">
          <div className="max-w-2xl" data-id="element-20" data-mp="1sygxhzwazd5t">
            <h2 className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-21" data-mp="1szi9c6l583ol">
              Esto te llevás hoy
            </h2>
            <p className="mt-3 font-sans text-base leading-relaxed text-muted" data-id="element-22" data-mp="3uqmxgsnvam46">
              400 recetas listas para imprimir o usar desde el celular, además del método y
              todos los bonos.
            </p>
          </div>
          <div className="flex items-center gap-2" data-id="element-23" data-mp="3p58e5jpyr5b5">
            <button type="button" onClick={() => go(-1)} aria-label="Recetario anterior" className="flex h-11 w-11 items-center justify-center rounded-full border border-ink/15 text-ink transition-colors duration-150 ease-soft hover:border-tomato hover:text-tomato focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-tomato" data-id="element-24" data-mp="3u39x84ne34mm">
              <ChevronLeftIcon aria-hidden="true" className="h-5 w-5" data-id="element-25" data-mp="gpezlaf703wq" />
            </button>
            <button type="button" onClick={() => go(1)} aria-label="Recetario siguiente" className="flex h-11 w-11 items-center justify-center rounded-full border border-ink/15 text-ink transition-colors duration-150 ease-soft hover:border-tomato hover:text-tomato focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-tomato" data-id="element-26" data-mp="lnq91k1kscef">
              <ChevronRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-27" data-mp="2bemut8jjo5yz" />
            </button>
          </div>
        </div>

        <div className="mt-8 grid items-center gap-8 rounded-2xl bg-cream p-5 sm:p-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-12" aria-live="polite" data-id="element-28" data-mp="2kd8amvxmt6w2">
          <div className="relative mx-auto w-full max-w-sm" data-id="element-29" data-mp="2yawuc0fyq7zj">
            <AnimatePresence mode="wait" data-id="element-30" data-mp="2uacz52ey9eg1">
              <motion.img key={item.image} src={item.image} alt={item.alt} initial={{
              opacity: 0,
              scale: 0.97
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: EASE
            }} className="w-full rounded-xl bg-white object-contain shadow-card" data-id="element-31" data-mp="2u9blqragofv5" />
            </AnimatePresence>
          </div>

          <div data-id="element-32" data-mp="jmj1ew8emku">
            <AnimatePresence mode="wait" data-id="element-33" data-mp="j2z5sn0to46">
              <motion.div key={item.tag} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -6
            }} transition={{
              duration: 0.2,
              ease: EASE
            }} data-id="element-34" data-mp="4jn0z9ijhfwn">
                <p className="font-sans text-xs font-bold uppercase tracking-[0.16em] text-tomato" data-id="element-35" data-mp="3rqfjggj7ahob">
                  {item.tag} de {deliverables.length}
                </p>
                <h3 className="mt-3 font-display text-4xl font-black leading-[1.05] text-ink sm:text-5xl" data-id="element-36" data-mp="3hrzuok7nbkhz">
                  {item.title}{' '}
                  <span className="block text-tomato" data-id="element-37" data-mp="38xv5s6c2oj53">{item.highlight}</span>
                </h3>
                <p className="mt-4 max-w-lg font-sans text-lg leading-relaxed text-ink/80" data-id="element-38" data-mp="2u143npb0ktbs">
                  {item.detail}
                </p>
                <p className="mt-5 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 font-sans text-sm font-semibold text-muted shadow-card" data-id="element-39" data-mp="2yym5kvqm68aa">
                  <DownloadIcon aria-hidden="true" className="h-4 w-4 text-olive" data-id="element-40" data-mp="16m1ytxidim6" />
                  PDF descargable e imprimible
                </p>
              </motion.div>
            </AnimatePresence>

            <ul className="mt-8 flex gap-3" data-id="element-41" data-mp="3nmgiyn46zzi6">
              {deliverables.map((d, i) => <li key={d.image} data-id="element-42" data-mp="3imlt8mw5lfyp" data-mpi={i}>
                  <button type="button" onClick={() => setIndex(i)} aria-label={`Ver ${d.title} ${d.highlight}`} aria-current={i === index} className={`block h-24 w-16 overflow-hidden rounded-lg border-2 bg-white transition-[border-color,transform] duration-150 ease-soft hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-tomato ${i === index ? 'border-tomato' : 'border-ink/10'}`} data-id="element-43" data-mp="3inn3wq99c0fw">
                    <img src={d.image} alt="" className="h-full w-full object-cover object-top" data-id="element-44" data-mp="1aeyqr1lma1gz" />
                  </button>
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-45" data-mp="1p4egqfdbq2vm">
              <CtaButton data-id="element-46" data-mp="1p3d3q5cqz6b9" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}